import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import styles from './TextButton.style';

const TextButton = ({ children, className, noPadding, ...other }) => {
  const classNames = clsx(styles.root, className, noPadding && styles.noPadding);
  return (
    <DefaultButton className={classNames} {...other}>
      {children}
    </DefaultButton>
  );
};

TextButton.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  noPadding: PropTypes.bool,
};

TextButton.defaultProps = {
  className: '',
  noPadding: false,
};

export default TextButton;
